import { useIntl } from '@edx/frontend-platform/i18n';
import { Button, OverlayTrigger, Tooltip } from '@openedx/paragon';
import { RiArrowRightSLine } from '@remixicon/react';
import { Link } from 'react-router-dom';
import messages from './messages';
import { LEVEL_CLASSES, normalizeEngagement, formatTooltipDate } from './activityMapUtils';

const getMonthLabels = (days, locale) => {
  const labels = [];
  let lastMonth = null;

  days.forEach((day, index) => {
    const month = new Date(day.date).getMonth();
    if (month !== lastMonth) {
      labels.push({
        name: new Date(day.date).toLocaleString(locale || undefined, { month: 'long' }),
        index,
      });
      lastMonth = month;
    }
  });

  return labels;
};

const ActivityMap = ({ engagementData }) => {
  const intl = useIntl();
  const { locale } = intl;

  const endDate = new Date();
  const startDate = new Date(endDate);
  startDate.setDate(startDate.getDate() - 29);

  const days = normalizeEngagement(
    engagementData,
    startDate.toISOString().slice(0, 10),
  );

  const monthLabels = getMonthLabels(days, locale);

  return (
    <>
      <div className="activity-map__section-header">
        <h2 className="activity-map__section-title">
          {intl.formatMessage(messages.learningActivityMap)}
        </h2>
        <Button
          variant="ghost-secondary"
          iconAfter={RiArrowRightSLine}
          size="sm"
          as={Link}
          to="/progress/activity-map"
        >
          {intl.formatMessage(messages.viewDetailedMap)}
        </Button>
      </div>

      <div className="activity-map__card">
        <span className="activity-map__subtitle">
          {intl.formatMessage(messages.lastMonthActivity)}
        </span>
        <div className="activity-map__grid">
          {days.map((day) => (
            <OverlayTrigger
              key={day.date}
              placement="top"
              overlay={<Tooltip id={`tooltip-${day.date}`}>{formatTooltipDate(day.date, locale)}</Tooltip>}
            >
              <div className={`activity-map__cell ${LEVEL_CLASSES[day.level]}`} />
            </OverlayTrigger>
          ))}
        </div>
        <div className="activity-map__months">
          {monthLabels.map((label) => (
            <span
              key={label.name}
              className="activity-map__month-label"
            >
              {label.name}
            </span>
          ))}
        </div>
      </div>
    </>
  );
};

export default ActivityMap;
